export default function(resolveYmapScript = () => {}) {
  return new Promise(resolve => {
    const ymapSrc = `https://api-maps.yandex.ru/2.1/?apikey=${process.env.VUE_APP_YMAP_API_KEY}&lang=ru_RU`;
    let ymapScript = document.querySelector(`script[src="${ymapSrc}"]`);

    if (!ymapScript) {
      let script = document.createElement("script");
      script.onload = () => {
        resolve(resolveYmapScript());
      };
      script.async = true;
      script.src = `https://api-maps.yandex.ru/2.1/?apikey=${process.env.VUE_APP_YMAP_API_KEY}&lang=ru_RU`;
      document.head.appendChild(script);
    } else {
      resolve(resolveYmapScript());
    }
  });
}
